<template>
  <company-custom :companyName="companyName">
    <div class="order-detail">
      <div class="content">
        <order-header
          :type="serviceType"
          :orderStatus="detail.orderStatus"
          :taskStatus="detail.taskStatus"
          :productType="productType"
          :detail="detail"
          :productName="detail.productName"
          :rightName="detail.rightName"
        >
        </order-header>

        <!-- 师傅信息 -->
        <!-- 安全检测和已取消 不显示师傅显示 -->
        <!-- 年检，不显示地图，如果没有师傅信息，直接隐藏 -->
        <order-card
          title="师傅信息"
          v-if="
            !(
              productType == 'FL40000002' ||
              detail.orderStatus == 'CANCEL' ||
              (serviceType == 'FL60000001' && !detail.providerWorkerName)
            )
          "
        >
          <div id="container" class="map-class" v-if="serviceType != 'FL60000001'"></div>
          <!-- 待派工和待派单，无师傅信息的 -->
          <div
            class="service-info"
            v-if="!(detail.taskStatus == 'DISPATCH_WAIT' || detail.orderStatus == 'DISPATCH_WAIT')"
          >
            <div class="info">
              <div class="icon"></div>
              <span class="name">{{ detail.providerWorkerName }}</span>
            </div>
            <a class="phone-call" :href="'tel:' + detail.providerWorkerPhone"></a>
          </div>
          <div class="waiting" v-else>
            已经受理您的服务申请，正在给您安排服务师傅，请稍等
          </div>
        </order-card>

        <!-- 核销二维码 -->
        <qr-code
          v-if="productType == 'FL40000002'"
          :orderStatus="detail.orderStatus"
          :taskStatus="detail.taskStatus"
          :qrCodeInfo="detail.qrcodeDTO"
          :productCategoryType="detail.productCategoryType"
        ></qr-code>

        <!-- 车辆信息 -->
        <order-card title="车辆信息">
          <!-- 外层div不能删除，避免共同order-card组件中card-content影响样式 -->
          <div>
            <div class="car-info" v-if="detail.carNo">
              <span class="title">车牌</span>
              <span class="desc">{{ detail.carNo }}</span>
            </div>
          </div>
        </order-card>

        <!-- 服务信息 -->
        <order-address
          :serviceType="serviceType"
          :customer="detail.contactName"
          :tel="detail.contactPhone"
          :productType="productType"
          :detail="detail"
        ></order-address>

        <!-- 订单信息 -->
        <div class="order-info">
          <span class="tips"
            >温馨提示:关闭当前页面后，您可通过紫金保险消息通知查看订单详情</span
          >
          <span class="desc">下单日期：{{ detail.createTime }}</span>
        </div>

        <!--  服务热线   -->
        <div class="hot-line">
          <div>
            24小时在线客服：<a
              style="color: #99c7ff; font-size: 16px"
              :href="'tel:' + servicePhone"
              >{{ servicePhoneTxt }}</a
            >
          </div>
        </div>

        <!--  取消订单  -->
        <div class="cancel-order" v-if="canCancelOrder">
          <div class="btn" @click="cancelOrderClick">取消订单</div>
        </div>

        <!-- 取消订单弹框 -->
        <van-dialog
          v-model="showCancelOrderDialog"
          show-cancel-button
          confirmButtonText="坚持取消"
          cancelButtonText="再考虑下"
          :confirm-button-color="cancelConfirmColor"
          :before-close="beforeClose"
        >
          <van-radio-group v-model="cancelReasonKey">
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, index) in reasonlist"
                :key="index"
                :title="item.value"
                @click="selectReason(item)"
              >
                <template #right-icon>
                  <van-radio :name="item.key" checked-color="#5F2689" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-dialog>
      </div>
    </div>
  </company-custom>
</template>
<script>
import OrderHeader from "./order-header.vue";
import OrderCard from "./order-card.vue";
import CompanyCustom from "@/components/CompanyCustom.vue";
import OrderAddress from "./order-address.vue";
import { Services, ZBServicePhone } from "@/common/constant.js";

import iconMapStart from "@/assets/img/icon_map_start.png";
import iconMapEnd from "@/assets/img/icon_map_end.png";
import iconMapRescue from "@/assets/img/icon_map_rescue.png";
import iconMapWorking from "@/assets/img/icon_map_working.png";

import { cookieSet } from "@/common/cookie";
import {
  safetyInspectOrderDetail,
  drivingOrderDetail,
  rescueOrderDetail,
  inspectOrderDetail,
  loginByChannelToken,
  commonDictQueryList,
  cancelOrder,
  getOrderDetailByCaseNo,
  orderDetail,
  orderCurrentData
} from "@/common/api.js";
import QrCode from "./qr-code.vue";

export default {
  components: {
    CompanyCustom,
    OrderHeader,
    OrderCard,
    OrderAddress,
    QrCode,
  },
  data() {
    return {
      serviceType: "",
      productType: "",
      detail: {},
      companyName: "",
      map: "",
      markers: [],
      // 救援地图
      latitude: "",
      longitude: "",
      toLatitude: "", // 目的地
      toLongitude: "", // 目的地
      polyline: [], // 路径规划
      startIcon: iconMapStart, //起点icon（师傅icon、救援icon、起点icon）
      endIcon: iconMapEnd, //终点icon（终点icon、师傅icon）
      showCancelOrderDialog: false,
      reasonlist: [],
      cancelReasonKey: "",
      cancelReasonTxt: "",
      cancelConfirmColor: "#C8C8C8",
      orderDetailId: "", //订单详情id
      servicePhone: ZBServicePhone.number,
      servicePhoneTxt: ZBServicePhone.text,
      channelToken: "",
      canCancelOrder: false,
      caseNo: "", //案件号
      companyNo: "", //公司编号
      timer: "", //定时器
      trackData: {}
    };
  },

  async created() {
    // TODO 获取公司标识
    this.companyName = "ZIJIN";
    this.initQuery();

    if (!this.channelToken) {
      this.$toast("路由参数有误");
      return;
    }
    await this.vaildChannelToken();
    await this.cancelReason();
  },
  mounted() {
    this.initMap();
  },
  methods: {
    //路由参数
    initQuery() {
      console.log(this.$route.query);

      if (this.$route.query.caseNo) {
        this.caseNo = this.$route.query.caseNo;
      }
      if (this.$route.query.companyNo) {
        this.companyNo = this.$route.query.companyNo;
      }
      if (this.$route.query.channelToken) {
        
        this.channelToken = this.$route.query.channelToken.replace(/\s/g, "+");
      }
      console.log("this.channelToken:" + this.channelToken);
    },
    async vaildChannelToken() {
      try {
        await loginByChannelToken({ channelToken: this.channelToken, companyNo: this.companyNo }).then((res) => {
          if (res.token) {
            if (document.domain.indexOf("vas") > -1 ||
              document.domain.indexOf("zengzhi") > -1) {
              cookieSet("token", res.token);
              cookieSet("signKey", res.token);
            }
            this.getOrderDetailID();
          } else {
            this.$toast(res.data.message);
          }
        });
      } catch (error) {}
    },
    //根据案件号查订单id
    async getOrderDetailID() {
      try {
        let rs = await getOrderDetailByCaseNo({
          caseNo: this.caseNo,
          companyNo: this.companyNo,
        });
        if (rs) {
          this.orderDetailId = rs.orderNo;
          this.getDetail();
        }
      } catch (error) {}
    },
    async cancelReason() {
      let rs = await commonDictQueryList({
        code: "WX_APP_CANCLE_REASON",
      });
      if (rs) {
        this.reasonlist = rs.kvs;
      }
    },
    async getDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
      }
      try {
        let data = await orderDetail({ orderNo: this.orderDetailId });
        if (data) {
          this.detail = data;
          this.productType = this.detail.productCategoryType;
          this.serviceType = this.detail.productCategoryParentType;
          //是否显示订单取消
          this.canCancelOrder = this.showCancelOrder();
          //代驾、救援，才显示地图
          if (this.serviceType == "FL10000001" || this.serviceType == "FL70000001" || this.serviceType == "FL90000001" || this.serviceType == "FLA0000001") {
            this.orderCurrentData()
            // this.trailLogic();
            // this.planningPolyline();

            if (this.detail.orderStatus != "CANCEL") {
              //15s实时轮询
              if (!this.timer) {
                const _this = this;
                this.timer = setInterval(function () {
                  _this.getDetail(true);
                }, 15000);
              }
            }
          } else {
            if (this.map) {
              // this.map.destroyed();
            }
          }
        }
        
      } catch (error) {
        console.log(error);
      }
      if (!noLoading) {
        this.$toast.clear();
      }
    },

    async orderCurrentData() {
      try {
        const res = await orderCurrentData({ orderNo: this.orderDetailId })
        if(res){
					this.trackData = res
          this.trailLogic();
				}
      } catch (error) {
        console.log(error);
      }
		},

    initMap() {
      if (!this.map) {
        var map = new AMap.Map("container");
        this.map = map;
      }
    },
    async planningPolyline(latitude,longitude) {
      this.map.remove(this.markers);
      this.markers = [];
      this.map.clearMap();
      //(拖车、代驾)已接单状态 和 非拖车已到达状态,要多加一个师傅实时的坐标
      if (
        this.detail &&
        ((["FL70000002", "FL10000002"].includes(this.detail.productCategoryType) &&
          (this.detail.taskStatus == "TAKE" || this.detail.taskStatus == 'START')) ||
          (!["FL70000002", "FL10000002"].includes(this.detail.productCategoryType) &&
            (this.detail.taskStatus == "ARRIVE" || this.detail.taskStatus == 'TAKE')))
      ) {
        var marker = new AMap.Marker({
          icon: iconMapWorking,
          position: [
            longitude,
            latitude,
          ],
        });
        marker.setMap(this.map);
        this.markers.push(marker);
        this.map.setFitView();
      }

      // 没有目标经纬度不进行路径规划
      if (!this.toLatitude || !this.toLongitude) {
        // 只有一个点
        var marker = new AMap.Marker({
          icon: this.startIcon,
          position: [this.longitude, this.latitude],
        });
        marker.setMap(this.map);
        this.markers.push(marker);
        this.map.setFitView();
        return;
      }

      // 没有起点不进行路径规划，在拖车、代驾，已到达05、开始作业06无终点会出现
      if (!this.latitude || !this.longitude) {
        // 只有一个点
        var marker = new AMap.Marker({
          icon: this.endIcon,
          position: [this.toLongitude, this.toLatitude],
        });
        marker.setMap(this.map);
        this.markers.push(marker);
        this.map.setFitView();
        return;
      }

      const _this = this;
      var driving = new AMap.Driving();
      // 根据起终点经纬度规划驾车导航路线
      // new AMap.LngLat(116.379028, 39.865042),
      // new AMap.LngLat(116.427281, 39.903719),
      driving.search(
        new AMap.LngLat(this.longitude, this.latitude),
        new AMap.LngLat(this.toLongitude, this.toLatitude),
        function (status, result) {
          if (status === "complete") {
            if (result.routes && result.routes.length) {
              // 绘制第一条路线，也可以按需求绘制其它几条路线
              drawRoute(result.routes[0]);
            }
          } else {
            console.log("获取驾车数据失败：" + result);
          }
        }
    );

    function drawRoute(route) {
      var path = parseRouteToPath(route);
      var startMarker = new AMap.Marker({
        position: path[0],
        icon: _this.startIcon,
        map: _this.map,
      });
      var endMarker = new AMap.Marker({
        position: path[path.length - 1],
        icon: _this.endIcon,
        map: _this.map,
      });
      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: "#ffeeee",
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: "#0091ff",
        lineJoin: "round",
      });
      routeLine.setMap(_this.map);

      // 调整视野达到最佳显示区域
      _this.map.setFitView([startMarker, endMarker, routeLine]);
    }

      // 解析DrivingRoute对象，构造成AMap.Polyline的path参数需要的格式
    function parseRouteToPath(route) {
        var path = [];
        for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i];
          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j]);
          }
        }
        return path;
      }
    },
    //取消订单
    cancelOrderClick() {
      this.showCancelOrderDialog = true;
      this.cancelReasonKey = "";
      this.cancelReasonTxt = "";
      this.cancelConfirmColor = "#C8C8C8";
    },
    //取消订单接口
    async cancelOrderRequest() {
      try {
        let rs = await cancelOrder({
          orderNo: this.orderDetailId,
          cancelReason: this.cancelReasonTxt,
        });
        this.getDetail();
      } catch (error) {
        console.log(error);
      }
    },
    beforeClose: function (action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === "confirm") {
        if (this.cancelReasonTxt) {
          this.cancelOrderRequest();
          done(); // 关闭提示框
        } else {
          done(false); //阻止关闭弹框
        }
      } else if (action === "cancel") {
        done(); // 关闭提示框
      }
    },
    selectReason(item) {
      this.cancelReasonKey = item.key;
      this.cancelReasonTxt = item.value;
      this.cancelConfirmColor = "#5f2689";
    },
    //订单是否超过十分种
    orderExceedTenMinutes() {
      let createTime = this.detail.createTime.replace(/-/g, "/");
      let createTimestamp = new Date(`${createTime}`).valueOf();
      let currTimes = new Date().valueOf();
      if (currTimes >= createTimestamp + 600000) {
        return true;
      } else {
        return false;
      }
    },
    showCancelOrder() {
      //任务状态：作业结束； 和订单状态：已取消，隐藏按钮
      if (
        ["WORK_END"].indexOf(this.detail.taskStatus) != -1 ||
        ["CANCEL"].indexOf(this.detail.orderStatus) != -1
      ) {
        return false;
      }
      //是否超过十分钟
      let isExceed = this.orderExceedTenMinutes();
      if (isExceed) {
        return false;
      }
      //已到达及之后的任务状态有：已到达(05)、作业开始(06)、作业结束(07)、已办理(03)
      //代驾已到达及之后隐藏
      if (this.serviceType === "FL70000001") {
        return !(["FINISH", "ARRIVE", "WORK_START"].indexOf(this.detail.taskStatus) != -1);
      }
      // orderStatus 00：待派单、01：处理中、02：待初审、03：初审退回、04：待终审、05：终审退回、06：终审通过、07：已办结、08：已取消、09：待补充
      return ["DISPATCH_WAIT", "PROCESSING", "ADD_INFO_WAIT"].indexOf(this.detail.orderStatus) != -1;
    },
    //轨迹逻辑
			trailLogic() {
				this.markers = []
				this.points = []
				// this.endIcon = iconMapEnd
				let data = this.trackData
				//拖车、代驾
				if([Services.Trailer, Services.Driving].indexOf(this.productType) != -1){
					// this.startIcon = iconMapStart
					//已到达05、开始作业06--师傅的实时位置到终点的路线图 ,如果师傅和终点都没有，只显示一个起点
					if(['ARRIVE','WORK_START'].indexOf(data.taskStatus) != -1){
						
						if(data.destLatitude || data.workerLatitude){
              this.latitude = data.workerLatitude;
              this.longitude = data.workerLongitude;
              this.toLatitude = data.destLatitude;
              this.toLongitude = data.destLongitude;
              this.startIcon = iconMapWorking;
              this.endIcon = iconMapEnd;
						}else{
							this.toLatitude = '';
							this.toLongitude = '';
							this.latitude = data.startLatitude;
							this.longitude = data.startLongitude;
							this.startIcon = iconMapStart
						}
						
					// 作业结束07、已办理03 --- 实际开始作业位置（备：起点）到作业结束点（备：终点）的路线图
					}else if(['WORK_END', 'FINISH'].indexOf(data.taskStatus) != -1) {
            this.latitude = data.workerStartLatitude
						this.longitude = data.workerStartLongitude
						this.toLatitude = data.workerEndLatitude
						this.toLongitude = data.workerEndLongitude
            this.startIcon = iconMapStart
					}else if(['CANCELING', 'CANCELING_FEE'].indexOf(data.taskStatus) != -1) {
            if(data.workerStartLatitude || data.workerEndLatitude){
              this.latitude = data.workerStartLatitude
              this.longitude = data.workerStartLongitude
              this.toLatitude = data.workerEndLatitude
              this.toLongitude = data.workerEndLongitude
              this.startIcon = iconMapStart
            }else{
              this.latitude = ''
              this.longitude = ''
              this.toLatitude = ""
					    this.toLongitude = ""
            }
					}else{
						//其它任务状态，或无状态，预估起点到终点的路线图
						this.latitude = data.startLatitude
						this.longitude = data.startLongitude
						this.toLatitude = data.destLatitude
						this.toLongitude = data.destLongitude

						//已接单，除连线外，需要多加一个师傅的点
						// if(data.taskStatus == 'TAKE' && data.workerLatitude){
						// 	this.markers = [{
						// 		latitude: data.workerLatitude,
						// 		longitude: data.workerLongitude,
						// 		iconPath: iconMapWorking,
						// 		width: 18,
						// 		height: 26
						// 	}]
						// 	this.points = [{latitude: data.workerLatitude, longitude: data.workerLongitude}]
						// }
					}
					//非拖车
				}else{
					//默认只显示显示救援点
					this.startIcon = iconMapRescue
					this.toLatitude = ""
					this.toLongitude = ""
					//已接单--师傅的实时位置到救援地点位置的路线
					if(data.taskStatus == 'TAKE' || data.taskStatus == 'START'){
						this.latitude = data.startLatitude 
						this.longitude = data.startLongitude 
						this.toLatitude = data.workerLatitude
						this.toLongitude = data.workerLongitude
						this.endIcon = iconMapWorking
						//已到达 -- 救援地点+师傅的实时位置，不连线
					}else if(data.taskStatus == 'ARRIVE'){
						this.latitude = data.startLatitude
						this.longitude = data.startLongitude
					}else{
						//其它状态或者无状态，只显示一个救援点
						this.latitude = data.startLatitude
						this.longitude = data.startLongitude
					}
				}
        this.planningPolyline(data.workerLatitude, data.workerLongitude);
			},
  },
  destroyed() {
    try {
      if (this.map) {
        // this.map.destroyed();
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
    } catch (error) {}
  },
};
</script>

<style lang="less" scoped>
.order-detail {
  background: #f9f9f9;
  width: 7.5rem;
  height: 100vh;
  font-size: 15px;

  //超过屏幕高度，仍然显示背景色
  .content {
    background: #f9f9f9;
  }

  .map-class {
    padding: 5px;
    height: 160px;
  }

  .service-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    align-content: center;
    padding-top: 10px;

    .info {
      display: flex;
      justify-content: row;
      align-items: center;
      margin: 0;
    }

    .name {
      font-size: 15px;
      margin-left: 10px;
    }

    .icon {
      flex: 0 0 36px;
      width: 36px;
      height: 36px;
      background: url(~@/assets/img/icon_head.png) no-repeat;
      background-size: 36px 36px;
      background-position: right center;
    }

    .phone-call {
      flex: 0 0 24px;
      width: 24px;
      height: 24px;
      background: url(~@/assets/img/icon_photo.png) no-repeat;
      background-size: 24px 24px;
      background-position: right center;
    }
  }

  .waiting {
    padding-top: 10px;
    color: #666666;
    text-align: center;
    align-content: center;
    line-height: 21px;
  }

  .car-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      text-align: left;
      width: 100%;
      font-size: 13px;
      color: #999999;
    }
    .desc {
      width: 100%;
      margin-top: 12px;
      font-size: 15px;
      color: #333333;
    }
  }

  .order-info {
    display: flex;
    flex-direction: column;
    margin: 10px 15px 0px;
    justify-content: center;
    text-align: center;
    .desc {
      font-size: 13px;
      color: #999999;
    }
    .tips {
      margin-bottom: 10px;
      font-size: 11px;
      color: #ff8148;
      line-height: 15px;
    }
  }

  .cancel-order {
    padding-bottom: 60px;
    font-size: 16px;
    color: var(--theme-color);
    display: flex;
    justify-content: center;

    .btn {
      text-align: center;
      line-height: 40px;
      height: 40px;
      width: 280px;
      background: #f5f3ff;
      border: 1px solid var(--theme-color);
      border-radius: 20px;
    }
  }

  .hot-line {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    font-size: 12px;
    color: #c8c8c8;
    padding-bottom: 60px;
  }

  /deep/ .van-cell__title {
    text-align: center;
  }
}
</style>
